import { useQuery } from '@tanstack/react-query'

import { GetParametrosProposta } from '@/features/proposta/http'
import { parametrosKeys } from '@/utils/parametros-query-keys'

export const useParametrosProposta = () => {
  return useQuery({
    queryKey: parametrosKeys.proposta(),
    queryFn: async () => new GetParametrosProposta().execute().then((res) => res.data),
  })
}
